const statusConfig = {
  "Pending": { bg: "#FEF3C7", text: "#D97706", border: "#FDE68A" },
  "Assigned": { bg: "#DBEAFE", text: "#2563EB", border: "#BFDBFE" },
  "In Progress": { bg: "#E0E7FF", text: "#4F46E5", border: "#C7D2FE" },
  "On Hold": { bg: "#FFEDD5", text: "#EA580C", border: "#FED7AA" },
  // Completed (job done on ground) — yellow until fully closed
  "Completed": { bg: "#FEF3C7", text: "#B45309", border: "#FDE68A" },
  "Cancelled": { bg: "#FEE2E2", text: "#DC2626", border: "#FECACA" },
};

// Green palette used when a Completed work order is fully closed (CMR + photos uploaded)
const CLOSED_CONFIG = { bg: "#D1FAE5", text: "#059669", border: "#A7F3D0" };

const StatusBadge = ({ status, isClosed = false }) => {
  const fullyClosed = isClosed && status === "Completed";
  const config = fullyClosed ? CLOSED_CONFIG : (statusConfig[status] || statusConfig["Pending"]);
  const label = fullyClosed ? "Closed" : status;

  return (
    <span
      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-sm text-xs font-semibold border"
      style={{
        backgroundColor: config.bg,
        color: config.text,
        borderColor: config.border,
      }}
      data-testid={`status-badge-${(fullyClosed ? "closed" : status).toLowerCase().replace(/ /g, "-")}`}
      title={
        fullyClosed
          ? "Fully closed — CMR and before/after photos uploaded"
          : status === "Completed"
            ? "Job done on ground — awaiting CMR + before/after photos to fully close"
            : status
      }
    >
      {fullyClosed && (
        <span
          aria-hidden
          className="w-1.5 h-1.5 rounded-full"
          style={{ backgroundColor: config.text }}
        />
      )}
      {label}
    </span>
  );
};

export default StatusBadge;
